import { render, staticRenderFns } from "./PatLogin.vue?vue&type=template&id=2859527f"
import script from "./PatLogin.vue?vue&type=script&lang=js"
export * from "./PatLogin.vue?vue&type=script&lang=js"
import style0 from "./PatLogin.vue?vue&type=style&index=0&id=2859527f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports